import L from "leaflet";

// Marker icon URL
const markerIconUrl = "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/";

// Create custom colored marker icons
export const greenIcon = new L.Icon({
  iconUrl: `${markerIconUrl}marker-icon-2x-green.png`,
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

export const redIcon = new L.Icon({
  iconUrl: `${markerIconUrl}marker-icon-2x-red.png`,
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

export const blueIcon = new L.Icon({
  iconUrl: `${markerIconUrl}marker-icon-2x-blue.png`,
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

export const violetIcon = new L.Icon({
  iconUrl: `${markerIconUrl}marker-icon-2x-violet.png`,
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

export const yellowIcon = new L.Icon({
  iconUrl: `${markerIconUrl}marker-icon-2x-yellow.png`,
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

export const orangeIcon = new L.Icon({
  iconUrl: `${markerIconUrl}marker-icon-2x-orange.png`,
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

export const goldIcon = new L.Icon({
  iconUrl: `${markerIconUrl}marker-icon-2x-gold.png`,
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

export const greyIcon = new L.Icon({
  iconUrl: `${markerIconUrl}marker-icon-2x-grey.png`,
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

// Custom competitor icon (1.8x bigger)
export const competitorIcon = new L.Icon({
  iconUrl: 'https://cdn.onoranzefunebricloud.com/misc/maps/competitor.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [45, 74],
  iconAnchor: [22, 74],
  popupAnchor: [2, -61],
  shadowSize: [74, 74]
});

// Custom partner icon (1.8x bigger)
export const partnerIcon = new L.Icon({
  iconUrl: 'https://cdn.onoranzefunebricloud.com/misc/maps/partner.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [45, 74],
  iconAnchor: [22, 74],
  popupAnchor: [2, -61],
  shadowSize: [74, 74]
});

// Helper function to get the appropriate icon by org status and type
export const getMarkerIcon = (org) => {
  if (!org) return blueIcon;
  
  // Disattiva (rosso)
  if (org.stato === "disattiva") {
    return redIcon;
  }
  
  // Attiva e free (blu)
  if (org.stato === "attiva" && org.tipo_istanza === "free") {
    return blueIcon;
  }
  
  // Attiva e production (verde)
  if (org.stato === "attiva" && org.tipo_istanza === "production") {
    return greenIcon;
  }
  
  // Attiva e demo (viola)
  if (org.stato === "attiva" && org.tipo_istanza === "demo") {
    return violetIcon;
  }
  
  // Default fallback
  return blueIcon;
}; 